'use client'
import { FocusLock } from '@core/ui-elements'
import { FC, FormEvent, useEffect, useRef, useState } from 'react'

export interface IHiddenBarcodeInput {
  handleSubmit: (barcode: string) => void
  disabled?: boolean
  returnInput?: (barcode: string) => void
}

export const HiddenBarcodeInput: FC<IHiddenBarcodeInput> = ({
  handleSubmit,
  disabled,
  returnInput,
}) => {
  const [productBarcode, setProductBarcode] = useState('')
  const barcodeInputRef = useRef<HTMLInputElement>(null)

  const handleProductScan = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault()
    handleSubmit(productBarcode)
    setProductBarcode('')
  }

  useEffect(() => {
    if (returnInput) {
      returnInput(productBarcode)
    }
  }, [productBarcode, returnInput])

  return (
    <FocusLock autoFocus={true} isDisabled={disabled} persistentFocus={true}>
      <form
        autoComplete="off"
        style={{
          width: '0',
          height: '0',
          overflow: 'hidden',
          opacity: '0',
        }}
        onSubmit={handleProductScan}
      >
        <label>
          Barcode:
          <input
            ref={barcodeInputRef}
            autoFocus
            autoComplete="off"
            disabled={disabled}
            id="barcode-input"
            inputMode="none"
            name="barcode-input"
            type="text"
            value={productBarcode}
            onChange={(e) => setProductBarcode(e.target.value)}
          />
        </label>

        <input type="submit" />
      </form>
    </FocusLock>
  )
}
